import React,{useState} from 'react'
import {Link} from "react-router-dom"
import "../assets/css/style.css"
import Typewriter from "typewriter-effect";
// import "react-simple-typewriter/dist/index.css"
import {FaPlay} from "react-icons/fa"
const Hero = () => {
  return (
    <>
      <section
        id="hero"
        className="d-flex flex-column justify-content-center"
      >
        <div className="hero-container" data-aos="fade-in">
          {/* <h1>Urro's Jan </h1> */}
          <h1>Saqib Diar</h1>
          <p>
            {/* I'm{" "} */}
            <span className="type">
              <Typewriter
                onInit={(typewriter) => {
                  typewriter
                    .typeString("Expert Node JS Backend Developer")
                    .pauseFor(1000)
                    .deleteAll()
                    .typeString("DJango Experts")
                    .pauseFor(1000)
                    .deleteAll()
                    .typeString("MySQL Expert")
                    .pauseFor(1000)
                    .deleteAll()
                    .typeString("MongoDB Expert")
                    .pauseFor(1000)
                    .deleteAll()
                    .typeString("Sequelize ORM")
                    .pauseFor(1000)
                    .deleteAll()
                    .typeString("Prisma ORM")
                    .pauseFor(1000)
                    .start();
                }}
              />
            
            </span>
          </p>
          <h4 className='slogan'>A satisfied customer is the best business strategy.</h4>
          
        <a href="https://www.youtube.com/embed/AI3WS-B5tVA">
        <div className='video'>
        <div className='play-btn'>
        <FaPlay className='play'/>
          </div>
        </div>
          </a>

        </div>
      </section>
    </>
  );
}

export default Hero